import { take, put, race } from 'redux-saga/effects';
import _isNil from 'lodash/isNil';
import { openModal, CLOSE_MODAL } from './Modal.reducers';

const RESOLVE_WAIT_FOR_MODAL = 'RESOLVE_WAIT_FOR_MODAL';
export const resolveWaitForModal = data => ({ type: RESOLVE_WAIT_FOR_MODAL, data });

export function* waitForModal(client, modalName = '', modalProps = {}) {
  yield put(openModal(modalName, modalProps));
  const [{ data: closeData } = {}, { data: resolveData } = {}] = yield race([
    take(CLOSE_MODAL),
    take(RESOLVE_WAIT_FOR_MODAL),
  ]);

  return !_isNil(closeData) ? closeData : resolveData;
}
